<template>
<div class="card-panel hoverable">
     <router-link
      to="/power/tariffs"
        class="waves-effect waves-light btn-small left"
    >Back</router-link>
    
    <div class="row">
        <div class="col s12 m12">
            <img :src="'ui/img/power/revised/'+$route.params.image+'.jpg'" class="responsive-img" alt="">
        </div>
    </div>
</div>

</template>

<script>
export default {
    name: 'CostComponent',
    data(){
        return{

        }
    },
    props:[
        
    ]
    
}
</script>

<style>

</style>